import { api } from "../../../../config";
import { uiNotify } from "../../actions";



export const getCatalog = () => (dispatch) => {
  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  dispatch(uiNotify({ text: "Loading data..." }));

  const ES_URL = `/api/es/catalog/all`;
  const PT_URL = `/api/pt/catalog/all`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL)
    .then((res) => res.json())

    .then((data) => {

      dispatch(catalogLoaded(data));
      dispatch(uiNotify({ text: "Catalog data loaded" }));
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};

export const CATALOG_LOADED = "CATALOG_LOADED";

export const catalogLoaded = (data) => ({
  type: CATALOG_LOADED,
  payload: {
    data: data,
  },
});

export const getPopups = () => (dispatch) => {
  const language = window.ferrero ? window.ferrero.locale : "es_ES";

  const ES_URL = `/api/es/popups`;
  const PT_URL = `/api/pt/popups`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL)
    .then((res) => res.json())

    .then((data) => {

      return dispatch(popupHydrate(data.popups));
    })

    .catch((error) => {
      console.log(error);
      return dispatch(error);
    });
};

export const POPUP_HYDRATE = "POPUP_HYDRATE";

export const popupHydrate = (data) => ({
  type: POPUP_HYDRATE,
  payload: {
    data: data,
  },
});

// export const FIND_POPUP = "FIND_POPUP";

// export const findPopup = (data) => ({
//   type: FIND_POPUP,
//   payload: {
//     data: data,
//   },
// });

// export const FIND_PRODUCTS = "FIND_PRODUCTS";

// export const searchProducts = (data) => ({
//   type: FIND_PRODUCTS,
//   payload: {
//     data: data,
//   },
// });

export const FILTER_MARCAS_PRODUCTS = "FILTER_MARCAS_PRODUCTS";

export const filterMarcasProducts = (data) => ({
  type: FILTER_MARCAS_PRODUCTS,
  payload: {
    data: data,
  },
});

export const FILTER_CATEGORIAS_PRODUCTS = "FILTER_CATEGORIAS_PRODUCTS";

export const filterCategoriasProducts = (data) => (dispatch) => {
  return Promise.resolve(
    dispatch({
      type: FILTER_CATEGORIAS_PRODUCTS,
      payload: {
        data: data,
      },
    })
  );
};

export const FILTER_PRODUCTS = "FILTER_PRODUCTS";

export const filterProducts = (data) => ({
  type: FILTER_PRODUCTS,
  payload: {
    data: data,
  },
});

export const FIND_BRAND_POPUP = "FIND_BRAND_POPUP";

export const findBrandPopup = (data) => ({
  type: FIND_BRAND_POPUP,
  payload: {
    data: data,
  },
});

export const FIND_CATEGORY_POPUP = "FIND_CATEGORY_POPUP";

export const findCategoryPopup = (data) => ({
  type: FIND_CATEGORY_POPUP,
  payload: {
    data: data,
  },
});



export const SET_SEARCH_KEY = "SET_SEARCH_KEY";

export const setSearchKey = (data) => ({
  type: SET_SEARCH_KEY,
  payload: {
    data: data,
  },
});